export default __webpack_public_path__ + "media/images/mailer/icon_person_add-8c1f6d8e6b7e29d0bdfe706be8ecea04.png";